import React, { useEffect, useRef, useState } from 'react';
import videojs from 'video.js';

const VideoPlayer = ({ src, user }) => {
  const videoNode = useRef(null);

  const videoJsOptions = {
    controls: true,
    preload: true,
    fluid: true,
    responsive: true,
    userActions: { hotkeys: true },
    playbackRates: [0.5, 1, 1.5, 2],
    controlBar: {
      pictureInPictureToggle: false
    },
    sources: [
      {
        src,
        type: 'video/mp4',
      },
    ],
  };

  useEffect(() => {
    const player = videojs(
      videoNode.current,
      videoJsOptions,
      function onPlayerReady() {
        console.log('onPlayerReady');
      },
    );

    if (!videoJsOptions.sources[0].src) {
      console.log('no source found');
    }
    return () => {
      if (player) {
        window.analytics.track(`Duration of video recording played`, {
          duration : player.currentTime(),
          user
        });
        player.dispose();
      }
    };
  }, []);

  return (
    <video
      ref={videoNode}
      className="video-js vjs-theme-fantasy"
    />
  );
};

export default VideoPlayer;
